import React, { FC, useCallback, useEffect } from 'react';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';
import { Badge, IconButton, useTheme } from '@material-ui/core';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import { useAppDispatch, useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import {
  changePanelContent,
  openSidePanel,
  SidePanelModes,
} from 'src/modules/shared/slices/sidePanel/sidePanelSlice';
import { useGetNotificationsQuery } from 'src/modules/shared/slices/comunications/notifications/notificationsApi';
import { setSelectedTab } from 'src/modules/shared/slices/comunications/notifications/notificationsSlice';
import { NotificationsIconMenuContainer } from './styled';
import { LogActionTypes, useDataLogging } from 'src/modules/shared/data-logging';

export const NotificationsIconMenu: FC = () => {
  const dispatch = useAppDispatch();
  const log = useDataLogging();
  const theme = useTheme();
  const { data } = useGetNotificationsQuery(true);
  const selectedTab = useAppSelector((state) => state.notifications.selectedTab);
  const isOpen = useAppSelector((state) => state.sidepanel.isOpen);

  useEffect(() => {
    if (data && data?.length > 0) return;
    if (selectedTab === 1) return;
    setSelectedTab(1);
  }, [data, dispatch, selectedTab]);

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      if (!isOpen) {
        log(LogActionTypes.NOTIFICATIONS_OPEN_SIDEPANEL);
        dispatch(openSidePanel(true));
      }
      dispatch(changePanelContent(SidePanelModes.NEWS));
    },
    [dispatch, isOpen, log]
  );

  return (
    <>
      <NotificationsIconMenuContainer className={'hide-on-print'}>
        <IconButton
          id="basic-button"
          style={{ padding: 0, lineHeight: 'normal' }}
          onClick={handleClick}
        >
          <Badge
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            badgeContent={data?.length}
            color="primary"
          >
            <FontAwesomeSpriteIcon
              icon={SpriteIconsLight.BELL}
              color={theme.palette.offblack}
              iconSize="lg"
            />
          </Badge>
        </IconButton>
      </NotificationsIconMenuContainer>
    </>
  );
};
